export type TaskState = 'Open' | 'InProgress' | 'Done' | 'Cancelled';
export type ActivityLinkType = 'Deal' | 'Investment';

export interface TaskListItem {
  id: string;
  title: string;
  assigneeUserId: string;
  state: TaskState;
  dueDateUtc: string | null;
  completedAtUtc: string | null;
  linkType: ActivityLinkType;
  linkId: string;
  /** Quem criou a tarefa (coluna "Criada por" do mock). */
  createdById: string;
  /** Codinome do Deal/Investment vinculado, resolvido no backend (coluna "Vínculo"). */
  linkCodename: string | null;
}

export interface TaskResponse extends TaskListItem {
  description: string | null;
  eTag: string;
}

export interface PagedResult<T> {
  items: T[];
  total: number;
  skip: number;
  take: number;
}

export const TASK_STATE_LABELS: Record<TaskState, string> = {
  Open: 'Aberta',
  InProgress: 'Em andamento',
  Done: 'Concluída',
  Cancelled: 'Cancelada',
};
